/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';
import { Collapse } from 'react-bootstrap';

export const Container = styled.div``;

export const QuestionContainer = styled.div`
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  color: #074f8c;
  font-weight: bold;
  font-size: 18;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const Question = styled.span``;

export const QuestionIcon = styled.i``;

export const AnswerContainer = styled(Collapse)`
  background-color: #ffffff;
  padding: 20px;
  margin-top: -10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
`;

export const Answer = styled.div`
  color: #808495;
`;

export const Separator = styled.hr`
  margin-top: -5px;
  height: 0.5px;
  opacity: 0.5;
`;
